//typed rfc tab to get this to generate
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Header = props => {
    const {branding} = props;
    return (        
        <div>
            <nav className="navbar navbar-expand-sm navbar-dark bg-danger mb-3 py-0">
                <div className="container">
                    <a href="/" className="navbar-brand">{branding}</a>
                    <div>
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <Link to="/" className="nav-link">
                                    <i className="fas fa-home"/> Home
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/contact/add" className="nav-link">
                                    <i className="fas fa-plus"/> Add
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/about" className="nav-link">
                                    <i className="fas fa-question"/> About
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/*}
            <h1>{branding}</h1>
            {/*<h1 style={headingStyle}>{branding}</h1>*/}
            {/*<h1 style={{color:'red', fontSize:'50px'}}>{branding}</h1>*/}
            {/*this is being received from the branding attr from app.js*/}
        </div>
    )
}

Header.defaultProps = {
    branding: "My App"
}

Header.propTypes = {
    branding: PropTypes.string.isRequired
}
/* can add styles this way
const headingStyle = {
    fontSize: '50px',
    color: 'red'
}
*/
export default Header;